import React from 'react';

import { Wrapper, Title } from './styles';

export class RadioGroup extends React.Component {
  static Wrapper = Wrapper;
  static Title = Title;
}
